import type { Expression } from 'mapbox-gl'
import { type MapboxGeoJSONFeature } from 'mapbox-gl'
import type { Position } from 'geojson'

export const booksRouteURL = process.env.REACT_APP_BOOKS_ROUTE_URL
export const booksEndpoint = 'bookdata/api/public/getBookDataGeoJson/'
export const booksRadiusEndpoint =
  'bookdata/api/public/getBookDataWithinRadiusGeoJson/'
export const initialLongitudePosition = -6
export const initialLatitudePosition = 44
export const radiusFromLocation = 1000000 // Degrees

export const paint = {
  'text-halo-width': 3,
  'text-halo-color': 'rgba(255, 255, 255, 1)',
  'text-halo-blur': 1
}

export const priority = ['match', ['get', 'iconType'], 'Area', 10, 100]

export const placesLayout = {
  'text-field': ['get', 'name'] as Expression,
  // 'text-field': 'name',
  'text-anchor': 'top' as const,
  'text-justify': 'center' as const,
  'text-size': 14,
  'icon-anchor': 'bottom' as const,
  'icon-image': [
    'match',
    ['get', 'iconType'],
    [
      'OtherHarbour',
      'Mooring',
      'Anchorage',
      'HarbourWithYachtFacilities',
      'YachtMarina',
      'Area',
      'CulturalInformation',
      'Almanac',
      'UserOtherHarbour',
      'UserMooring',
      'UserAnchorage',
      'UserHarbourWithYachtFacilities',
      'UserYachtMarina',
      'UserArea',
      'UserCulturalInformation',
      'UserAlmanac'
    ],
    ['get', 'iconType'],
    'pin'
  ] as Expression,
  'symbol-sort-key': priority as Expression
}

export type Location = {
  lng: number
  lat: number
  id: string
  path: string
  name: string
  region: string | null
  location_types: string
  facilities: string
  book: string
  edition: string
  chapter: string
  multiple_locations?: Location[]
}

export interface BuildGeoJSONProps {
  id: string
  name: string
  iconType: string
  position: string | Position
}

export interface SelectionType {
  source: string
  id: string | number | undefined
}

export type FeatureLayer = 'places' | 'user-generated-locations' | 'social'

export type FeatureCallback = (
  feature: MapboxGeoJSONFeature | undefined,
  layer: FeatureLayer
) => void
